<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1AjygWR/tc-custom/9781467440462.jpg?1742010799534" alt="This image is the cover for the book Hauerwas, Interventions (INT)"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hauerwas, Interventions (INT)
      </h1>
      <p class="bookDescription body article font2">
        <p>Stanley Hauerwas is one of the most important and robustly creative theologians of our time, and his work is well known and much admired. But Nicholas Healy -- himself an admirer of Hauerwas’s thought -- believes that it has not yet been subjected to the kind of sustained critical analysis that is warranted by such a significant and influential Christian thinker. As someone interested in the broader systematic-theological implications of Hauerwas’s work, Healy fills that gap in <i>Hauerwas: A (Very) Critical Introduction</i>.<br/><br/>After a general introduction to Hauerwas’s work, Healy examines three main areas of his thought: his method, his social theory, and his theology. According to Healy, Hauerwas’s overriding concern for ethics and church-based apologetics so dominates his thinking that he systematically distorts Christian doctrine. Healy illustrates what he sees as the deficiencies of Hauerwas’s theology and argues that it needs substantial revision.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Nicholas M. Healy
      </h2>
      
      <p class="authorDescription body article">Nicholas M. Healy is professor of theology and religious studies at St. John&#39;s University, Jamaica, New York. His other books are Church, World and the Christian Life: Practical-Prophetic Ecclesiology and Thomas Aquinas: Theologian of the Christian Life.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6fe2c8a4